import React, { Component } from 'react'
import Outernavbar from './outernavbar.component'
import axios from 'axios';
import { Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';

export default class ResetPassword extends Component {
    constructor(props) {
        super(props)
        //const udata = localStorage.getItem('user')
        let  passwordchanged = false
        
        this.onChangeconfirmPassword = this.onChangeconfirmPassword.bind(this);
        this.onChangePassword = this.onChangePassword.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            confirmPassword: '',
            password: '',
            passwordchanged,
            errorMessage: '', // New state for error message
            loading: false // New state for loading spinner
        }
    }

    onChangeconfirmPassword(e) {
        this.setState({ confirmPassword: e.target.value })
    }
    onChangePassword(e) {
        this.setState({ password: e.target.value })
    }
    onSubmit(e) {
        e.preventDefault()

        this.setState({ loading: true }); // Show spinner when form is submitted

        if(this.state.password!=this.state.confirmPassword){

            this.setState({
                    errorMessage: "Password and Confirm password do not match", // Set error message
                    loading: false // Hide spinner on error
                })

        }else{

        const userObject = {
            email: sessionStorage.getItem("resetEmail"),
             otp: sessionStorage.getItem("resetOtp"),
            password: this.state.password
        };
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/reset`, userObject)
            .then((res) => {
                if (res.status === 200) {
                    this.setState({
                        passwordchanged: true,
                        errorMessage: '', // Clear error message on success
                        loading: false // Hide spinner on success
                    })


                    sessionStorage.removeItem("resetEmail");
                    sessionStorage.removeItem("resetOtp");
                  //  localStorage.setItem('user', JSON.stringify(res.data))
                }
            }).catch((error) => {
                this.setState({
                    errorMessage: "Wrong email or password", // Set error message
                    loading: false // Hide spinner on error
                })
            });
       

        }
    }

    render() {
        if (this.state.passwordchanged) {
            return <Navigate to="/sign-in" />
        }
        return (
            <div className='App'>
                <Outernavbar />
                <div className="auth-wrapper">
                    <div className="auth-inner">
                        <form onSubmit={this.onSubmit}>

                            <h3>Reset Password</h3>
                            <p className="forgot-password text-right">
                                Don't have an account <a href="/sign-up">join us?</a>
                            </p>
                            <div className="mb-3">
                                <label>Enter Password </label>
                                <input
                                    type="password"
                                    className="form-control"
                                    placeholder="Enter Password"
                                    onChange={this.onChangePassword}
                                    name="email"
                                    value={this.state.password}
                                />
                            </div>
                            <div className="mb-3">
                                <label>Confirm password</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    placeholder="Enter confirm password"
                                    onChange={this.onChangeconfirmPassword}
                                    name="password"
                                    value={this.state.confirmPassword}
                                />
                            </div>
                            <div className="mb-3">
                                <div className="custom-control custom-checkbox" >
                                    <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="customCheck1"
                                    />
                                    <label className="custom-control-label" htmlFor="customCheck1">
                                        Remember me
                                    </label>
                                </div>
                               
                            </div>
                            {this.state.errorMessage && (
                                <div className="alert alert-danger" role="alert">
                                    {this.state.errorMessage}
                                </div>
                            )}
                            <div className="d-grid">
                                <button type="submit" className="btn btn-primary" disabled={this.state.loading}>
                                    {this.state.loading ? (
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    ) : 'Submit'}
                                </button>
                            </div>
                        </form>
                        <GoogleOAuthProvider clientId="386932037035-k8v833noqjk7m4***********.apps.googleusercontent.com">
                            <React.StrictMode>
                                <App />
                            </React.StrictMode>
                        </GoogleOAuthProvider>
                    </div>
                </div>
            </div>
        )
    }
}
